import HomePage from "@/pages/HomePage";

export default {
    path: '/',
    name: 'home',
    component: HomePage
}